import { useEffect, useState } from 'react';
import * as MapGL from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import { homeMapStore } from '../store';

const CLUSTER_ZOOM = 17;

export const AddressSearchResult = () => {
  const { current: map } = MapGL.useMap();
  const [popupParams, setPopupParams] = useState<{
    lngLat: [number, number];
    address: string;
  }>();
  const [isProjectOptionsVisible, setIsProjectOptionsVisible] = useState(false);

  const { addressSearchResult } = useSnapshot(homeMapStore);

  useEffect(() => {
    if (!map || !addressSearchResult) return;

    map
      .jumpTo({
        center: addressSearchResult.lngLat as [number, number],
        zoom: CLUSTER_ZOOM,
      })
      .once('render', () => {
        setPopupParams({
          lngLat: Reflect.get(addressSearchResult, 'lngLat') as [number, number],
          address: addressSearchResult.address,
        });
      });
  }, [map, addressSearchResult]);

  const resetValues = () => {
    setPopupParams(undefined);
    setIsProjectOptionsVisible(false);
    homeMapStore.setAddressSearchResult(undefined);
  };

  return (
    <>
      {popupParams && (
        <MapGL.Popup
          longitude={popupParams.lngLat[0]}
          latitude={popupParams.lngLat[1]}
          closeButton={false}
          closeOnMove={true}
          maxWidth="auto"
          onClose={resetValues}
        >
          <div className="space-y-2 p-2">
            <div className="text-base">{popupParams.address}</div>
            {/* {isProjectOptionsVisible ? (
              <div className="flex flex-col space-y-2 bg-white p-4">
                <Button
                  icon="PlusIcon"
                  size="small"
                  buttonStyle="outline"
                  onClick={() => {
                    resetValues();
                    homeMapStore.setEditorMode(EditorMode.DrawLine);
                  }}
                >
                  Linear
                </Button>
                <Button
                  icon="PlusIcon"
                  size="small"
                  buttonStyle="outline"
                  onClick={() => {
                    resetValues();
                    homeMapStore.setEditorMode(EditorMode.DrawPolygon);
                  }}
                >
                  Polygon
                </Button>
              </div>
            ) : (
              <div className="flex flex-col space-y-2 bg-white p-4">
                <Button
                  size="small"
                  onClick={() => setIsProjectOptionsVisible(true)}
                >
                  Create Project Here
                </Button>
              </div>
            )} */}
          </div>
        </MapGL.Popup>
      )}
    </>
  );
};
